import { render, staticRenderFns } from "./CertificationView.vue?vue&type=template&id=585127f7&"
import script from "./CertificationView.vue?vue&type=script&lang=js&"
export * from "./CertificationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports